exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-spin[data-v-4d976fac] {\n  font-size: 40px;\n}\n.search-type[data-v-4d976fac] {\n  height: 38px !important;\n}\n.w-100[data-v-4d976fac] {\n  width: 100% !important;\n}\n.table-orders select[data-v-4d976fac] {\n  text-transform: uppercase;\n  font-size: 11px;\n  font-weight: bold;\n  height: 30px !important;\n}\n.fast_track_info[data-v-4d976fac] {\n  margin-top: 10px;\n  color: #5e72e4;\n  display: block;\n  font-size: 20px;\n}\n", ""]);

// exports
